import React from 'react'
import cls from './inputAlert.module.scss'

export const InputError = ({ children, ...props }) => {
  return (
    <div {...props} className={cls['input__alert--error']} role="alert">
      {children}
    </div>
  )
}

export default InputError
